import {Flex} from '@mantine/core';
import React from 'react';

import {StructuredTable, StructuredTableAdapter} from 'notebook/structured-tables/StructuredTableConstants';

export interface GetFooterInformationParams<TTableMetadata, TRowMetadata> {
  entryId: string | null;
  structuredTable: StructuredTable<TTableMetadata, TRowMetadata>;
  adapter: StructuredTableAdapter<TTableMetadata, TRowMetadata>;
}

export default function getFooterInformation<TTableMetadata, TRowMetadata>(
  params: GetFooterInformationParams<TTableMetadata, TRowMetadata>
): JSX.Element | null {
  const footerInfoRenderers = params.adapter.getFooterInformation();
  if (!footerInfoRenderers || footerInfoRenderers.length === 0) {
    return null;
  }
  return (
    <Flex align="center" gap="sm">
      {footerInfoRenderers.map((renderer, index) => (
        <React.Fragment key={index}>{renderer(params)}</React.Fragment>
      ))}
    </Flex>
  );
}
